import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmCustomerAPI {
    /**
     * 
     * @param Object config {production: bool, siteToken: ''}
     * @return {[type]}
     */
    constructor(config) {
        this.config = config;
    }

    // getting URLs
    getRootURL() {
        if (this.config.production) {
            return "https://customers.dev.pixelmotiondemo.com/";
        }
        if (this.config.dev) {
            return "http://localhost:3000/";
        }
        return "http://localhost:85/";
    }

    getURL() {
        return this.getRootURL() + "api";
    }

    saveCustomerTrackingActivity(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/customerEvent/save/" + this.config.siteToken, data, successCallback, errorCallback);
    }

    saveCustomer(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/customer/createUpdate/", data, successCallback, errorCallback);
    }

    createCustomerJourneyCTA(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/customerJourney/createCustomerJourneyCTA/" + data.sessionId + "/" + data.siteToken, data, successCallback, errorCallback);
    }

    createCustomerJourney(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/customerJourney/createCustomerJourney/" + data.sessionId + "/" + data.siteToken + "/" + data.customerId + "/" + data.leadId + "/" + data.CJId, data, successCallback, errorCallback);
    }

    updateCustomerJourney(data, successCallback, errorCallback) {
        RequestHelper.ajax("POST", this.getURL() + "/customerJourney/updateCustomerJourney/" + data.CJId + "/" + data.sessionId, {}, successCallback, errorCallback);
    }

    addAdditionalStepsToCJ(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "/customerJourney/addAdditionalSteps/" + data.CJId + "/" + data.sessionId, successCallback, errorCallback);
    }
}